import { Card } from "@/components/ui/card";
import { Clock } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { formatDistanceToNow } from "date-fns";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const MODEL_DISPLAY_NAMES: Record<string, string> = {
  'gpt-4o': 'Extended',
  'gpt-4o-mini': 'Efficient'
};

export const TransactionHistory = () => {
  const { data: transactions, isLoading: isLoadingTransactions } = useQuery({
    queryKey: ['tokenTransactions'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('token_transactions')
        .select(`
          *,
          token_model_costs (
            model_name
          )
        `)
        .order('created_at', { ascending: false })
        .limit(10);
      
      if (error) throw error;
      return data;
    },
  });

  const getModelDisplayName = (modelName: string | null) => {
    if (!modelName) return "-";
    return MODEL_DISPLAY_NAMES[modelName] || modelName;
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
        <Clock className="h-6 w-6" />
        Recent Transactions
      </h2>
      <Card className="p-6">
        {isLoadingTransactions ? (
          <div>Loading transactions...</div>
        ) : !transactions?.length ? (
          <div className="text-muted-foreground">No transactions yet</div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Date</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Amount</TableHead>
                <TableHead>Model</TableHead>
                <TableHead>Description</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {transactions.map((transaction) => (
                <TableRow key={transaction.id}>
                  <TableCell>
                    {formatDistanceToNow(new Date(transaction.created_at), { addSuffix: true })}
                  </TableCell>
                  <TableCell className="capitalize">{transaction.transaction_type}</TableCell>
                  <TableCell className={transaction.amount > 0 ? "text-green-600" : "text-red-600"}>
                    {transaction.amount > 0 ? "+" : ""}{transaction.amount}
                  </TableCell>
                  <TableCell>{getModelDisplayName(transaction.token_model_costs?.model_name)}</TableCell>
                  <TableCell>{transaction.description || "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Card>
    </div>
  );
};